module.exports = __webpack_public_path__ + "media/images/hexagon-12c74ec48244777b4ef87146ef0e2b22.svg";